/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import ActionButton, { actionButtonTypes } from "./ActionButton";

const ActionButtonGroup = (props) => {
  // parse out default props
  const {
    className,
    style,
    backgroundColor = "#FFF8",
    disabled = false,
  } = props;

  // helpers
  const getHandler = (type) => props[`${type}Handler`]; 
  const getDisabled = (type) => disabled || props[`${type}Disabled`];
  const getTooltip = (type) => !getDisabled(type) && props[`${type}Tooltip`];

  return (
    <div className={className} style={style}>
      <div className="d-flex">
        {Object.keys(actionButtonTypes).filter(type => getHandler(type) != null).map((type, index) => (
          <div
            key={index}
            className={index !== 0 ? "ms-1" : ""}
            style={{ backgroundColor: backgroundColor, borderRadius: "4px" }}
          >
            <ActionButton
              type={type}
              onClick={getHandler(type)}
              disabled={getDisabled(type)}
              tooltip={getTooltip(type)}  
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActionButtonGroup;
